import React from "react";

const Banner = ({ image, title, productImage }) => {
  return (
    <>
      <div className={`homepage-banner ${!productImage && "default"}`}>
        <div className="img" style={{ background: `url(${image})` }}>
          <div className="bottom-center">{title}</div>
        </div>
      </div>
      {productImage && (
        <div className="page-layout-1column">
          <div className="product media ">
            <a id="gallery-prev-area" tabIndex={-1} />
            <div className="action-skip-wrapper">
              <a
                className="action skip gallery-next-area"
                href="#gallery-next-area"
              >
                <span>Skip to the end of the images gallery </span>
              </a>
            </div>
            <div
              className="gallery-placeholder"
              data-gallery-role="gallery-placeholder"
            >
              <div className="fotorama--hidden" />
              <style dangerouslySetInnerHTML={{ __html: "" }} />
              <div
                className="fotorama-item fotorama fotorama1695633850696"
                data-gallery-role="gallery"
              >
                <div
                  data-gallery-role="fotorama__focusable-start"
                  tabIndex={-1}
                />
                <div
                  className="fotorama__wrap fotorama__wrap--css3 fotorama__wrap--slide fotorama__wrap--no-controls"
                  style={{ minWidth: 0, maxWidth: "100%" }}
                >
                  <div
                    className="fotorama__stage"
                    data-fotorama-stage="fotorama__stage"
                    // style={{ width: 195, height: 195 }}
                  >
                    <div
                      className="fotorama__arr fotorama__arr--prev fotorama__arr--disabled"
                      tabIndex={-1}
                      role="button"
                      aria-label="Previous"
                      data-gallery-role="arrow"
                      disabled="disabled"
                      style={{ display: "none" }}
                    >
                      <div className="fotorama__arr__arr" />
                    </div>
                    <div
                      className="fotorama__stage__shaft"
                      tabIndex={0}
                      data-gallery-role="stage-shaft"
                      style={{
                        transitionDuration: "0ms",
                        transform: "translate3d(0px, 0px, 0px)",
                        // width: 195,
                        marginLeft: 0,
                      }}
                    >
                      <div
                        className="fotorama__stage__frame fotorama__active fotorama_vertical_ratio fotorama__loaded fotorama__loaded--img"
                        aria-hidden="false"
                        data-active="true"
                        href="https://store.eclear.com/media/catalog/product/cache/853d89fdf4fa55295543cbc3579aebe2/2/2/221130_store_kacheln_800x800.jpg"
                      >
                        <img
                          src={productImage}
                          alt="ClearVAT"
                          className="fotorama__img"
                          aria-hidden="false"
                        />
                      </div>
                    </div>
                    <div
                      className="fotorama__arr fotorama__arr--next fotorama__arr--disabled"
                      tabIndex={-1}
                      role="button"
                      aria-label="Next"
                      data-gallery-role="arrow"
                      disabled="disabled"
                      style={{ display: "none" }}
                    >
                      <div className="fotorama__arr__arr" />
                    </div>
                    <div className="fotorama__video-close" />
                    <div
                      className="fotorama__zoom-in"
                      data-gallery-role="fotorama__zoom-in"
                      aria-label="Zoom in"
                      role="button"
                      tabIndex={0}
                    />
                    <div
                      className="fotorama__zoom-out"
                      data-gallery-role="fotorama__zoom-out"
                      aria-label="Zoom out"
                      role="button"
                      tabIndex={0}
                    />
                    <div className="fotorama__spinner" />
                  </div>
                  <div
                    className="fotorama__nav-wrap"
                    data-gallery-role="nav-wrap"
                    style={{ display: "none" }}
                  >
                    <div className="fotorama__nav" style={{ height: 94 }}>
                      <div
                        className="fotorama__thumb__arr fotorama__thumb__arr--left fotorama__arr--disabled"
                        role="button"
                        aria-label="Previous"
                        data-gallery-role="arrow"
                        tabIndex={-1}
                        style={{ display: "none" }}
                        disabled="disabled"
                      >
                        <div className="fotorama__thumb--icon" />
                      </div>
                      <div className="fotorama__nav__shaft fotorama__grab">
                        <div className="fotorama__thumb-border" />
                      </div>
                      <div
                        className="fotorama__thumb__arr fotorama__thumb__arr--right"
                        role="button"
                        aria-label="Next"
                        data-gallery-role="arrow"
                        tabIndex={-1}
                        style={{ display: "none" }}
                      >
                        <div className="fotorama__thumb--icon" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-gallery-role="fotorama__focusable-end"
                  tabIndex={-1}
                />
              </div>
              <div
                className="magnifier-preview magnify-hidden"
                data-gallery-role="magnifier"
                id="preview"
                style={{ display: "none" }}
              />
            </div>
            <div className="action-skip-wrapper">
              <a
                className="action skip gallery-prev-area"
                href="#gallery-prev-area"
              >
                <span>Skip to the beginning of the images gallery </span>
              </a>
            </div>
            <a id="gallery-next-area" tabIndex={-1} />
          </div>
        </div>
      )}
    </>
  );
};
export default Banner;
